import { Routes } from '@angular/router';
import { AutoLoginGuard } from './shared/guards/auto-login.guard';
import { AuthGuard } from './shared/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'pages',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.default),
    canActivate: [AutoLoginGuard],
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.routes').then(m => m.default),
    canActivate: [AuthGuard],
  },
];
